'use strict';

var _ = require('lodash');
var MultiSelectComboboxFactory = function MultiSelectComboboxFactory(MultiSelectComboboxListItemFactory, MultiSelectComboboxSelectAllFactory, multiSelectComboboxService, MultiSelectComboboxKeyHandlersFactory, MultiSelectComboboxVirtualScrollingHelper) {
  /**
   *
   * @param {jQuery} elem
   * @param {Array.<{value: string, dropdownVisibleValue: string, selected: (boolean=}>} comboboxValues
   * @param {function} onChangeCallback
   * @param eventHandlers
   * @param {Integer} selectionLimit
   * @param {Integer} minSelection
   * @param {Integer} dynamicDropdownWidth
   * @param {Integer} listItemHeight
   * @constructor
   */
  var Widget = function Widget(elem, comboboxValues, onChangeCallback, eventHandlers, selectionLimit, minSelection, dynamicDropdownWidth, listItemHeight) {
    this.MARGIN = 10;
    this.comboboxElements = [];
    this.visibleComboboxElements = [];
    this.prevSelectedValuesString = '';
    this.inputDomElement = elem.find(':text');
    //dropdownListWrapper was created due problem with detecting position of li elements
    this.dropdownListWrapper = elem.find('.rm-list-wrapper');
    this.dropdownPlaceholder = elem;
    this.wrongValues = [];
    this.silentFocus = false;
    this.isDropdownVisible = false;
    //on rendering widget shows only first 100 symbols in input field due to performance reason.
    //On focus it update value and show all values
    this.wasFocused = false;
    this.eventHandlers = eventHandlers;
    this.selectionLimit = selectionLimit || 0;
    this.minSelection = minSelection || 0;
    this.dynamicDropdownWidth = dynamicDropdownWidth || false;
    /**
     * List of selected values - "value" property from given "option" element
     * @type {Array.<string>}
     */
    this.selectedValues = [];
    this.onChangeCallback = onChangeCallback;
    //bind to "this" methods
    _.bindAll(this, ['onSelectionChange', 'setCursorToLastSymbol']);
    this.activeElement = null;
    this.selectAllElement = new MultiSelectComboboxSelectAllFactory();
    this.virtualScrollingHelper = new MultiSelectComboboxVirtualScrollingHelper(this.dropdownListWrapper, this.onSelectionChange, undefined, undefined, listItemHeight);
    this.render(comboboxValues);
    this.initEvents();
  };
  //copy to prototype all methods from mixin
  _.assign(Widget.prototype, MultiSelectComboboxKeyHandlersFactory);
  Widget.prototype.setCursorToLastSymbol = function () {
    setTimeout(function () {
      var valueLength = this.inputDomElement.val().length;
      this.inputDomElement[0].setSelectionRange(valueLength, valueLength);
    }.bind(this), 0);
  };
  Widget.prototype.showDropdown = function () {
    this.isDropdownVisible = true;
    this.dropdownPlaceholder.addClass('open');
  };
  Widget.prototype.hideDropdown = function () {
    this.isDropdownVisible = false;
    this.dropdownPlaceholder.removeClass('open');
  };
  Widget.prototype.onDropdownHidden = function () {
    this.isDropdownVisible = false;
    var inputValue = this.inputDomElement.val();
    inputValue = inputValue.replace(/^([ ]*)(.*?)([, ]*)$/, '$2');
    this.inputDomElement.val(inputValue);
    if (inputValue[inputValue.length - 1] !== ',') {
      inputValue += ',';
    }
    this.selectElementsByInput(inputValue);
    if (this.eventHandlers.onDropdownHidden) {
      this.eventHandlers.onDropdownHidden(inputValue);
    }
  };
  Widget.prototype.onFocusHandler = function () {
    if (this.silentFocus) {
      return;
    }
    if (!this.isDropdownVisible || !this.wasFocused) {
      var value = this.wasFocused ? this.inputDomElement.val().trim() : this.prevSelectedValuesString;
      if (value !== '' && value[value.length - 1] !== ',' && !this.wrongValues.length) {
        this.inputDomElement.val(value + ',');
      }
    }
    this.wasFocused = true;
    this.denyHideDropdown();
    this.setCursorToLastSymbol();
  };
  Widget.prototype.denyHideDropdown = function () {
    this.dropdownPlaceholder.on('hide.bs.dropdown', function (event) {
      event.preventDefault();
    });
  };
  Widget.prototype.onBlurHandler = function () {
    if (this.silentFocus) {
      return;
    }
    this.dropdownPlaceholder.off('hide.bs.dropdown');
    if (!this.isDropdownVisible) {
      this.onDropdownHidden();
    }
  };
  Widget.prototype.initEvents = function () {
    var that = this;
    this.inputDomElement.on('focus', this.onFocusHandler.bind(this));
    this.inputDomElement.on('blur', this.onBlurHandler.bind(this));
    //onInputHandler and onKeyPressHandler was moved to mixin
    this.inputDomElement.on('input', this.onInputHandler.bind(this));
    this.inputDomElement.on('keydown', this.onKeyPressHandler.bind(this));
    this.dropdownPlaceholder.on('shown.bs.dropdown', function () {
      that.inputDomElement.focus();
      that.isDropdownVisible = true;
      if (!that.wrongValues.length) {
        that.toggleDisability();
        var visibleElements = multiSelectComboboxService.showAllComboboxElements(that.comboboxElements, that.selectAllElement, that.selectionLimit);
        that.virtualScrollingHelper.render(visibleElements);
      }
      if (that.dynamicDropdownWidth) {
        var dropdownMenu = that.dropdownPlaceholder.find('.dropdown-menu');
        var dropDownItems = dropdownMenu.find('.rm-multi-dropdown-item');
        var maxDropdownElementsWidth = multiSelectComboboxService.getElementsMaxWidth(dropDownItems);
        if (dropdownMenu.width() < maxDropdownElementsWidth) {
          dropdownMenu.css('width', maxDropdownElementsWidth + that.MARGIN + 'px');
        }
      }
    });
    this.dropdownPlaceholder.on('hidden.bs.dropdown', this.onDropdownHidden.bind(this));
    this.dropdownPlaceholder.find('.dropdown-menu').on('click', function (event) {
      event.stopPropagation();
    });
    this.dropdownPlaceholder.on('$destroy', this.virtualScrollingHelper.destroy.bind(this.virtualScrollingHelper));
  };
  Widget.prototype.selectAllItems = function (state) {
    multiSelectComboboxService.selectAll(this.comboboxElements, state);
    this.updateDataModel();
    this.updateResultField();
    this.inputDomElement.focus();
  };
  Widget.prototype.updateResultField = function (inputValue) {
    if (_.isNil(inputValue)) {
      inputValue = multiSelectComboboxService.getInputFieldValue(this.comboboxElements);
      if (this.isDropdownVisible && inputValue !== '') {
        inputValue += ',';
      }
    }
    if (!this.wasFocused) {
      this.inputDomElement.val(inputValue.substr(0, 100));
    } else {
      this.inputDomElement.val(inputValue);
    }
    this.prevSelectedValuesString = inputValue;
  };
  Widget.prototype.updateDataModel = function () {
    this.selectedValues = multiSelectComboboxService.getDataModelValue(this.comboboxElements);
    if (this.wrongValues && this.wrongValues.length) {
      //undefined because it is impossible to detect exact values
      this.onChangeCallback(undefined);
    } else {
      this.onChangeCallback(this.selectedValues);
    }
  };
  Widget.prototype.validateSelectionLimit = function (data) {
    if (_.countBy(this.comboboxElements, 'selected')["true"] > this.selectionLimit) {
      data.selected = !data.selected;
    }
  };
  Widget.prototype.validateMinSelection = function (data) {
    if ((_.countBy(this.comboboxElements, 'selected')["true"] || 0) < this.minSelection) {
      data.selected = !data.selected;
    }
  };
  Widget.prototype.toggleDisability = function () {
    if (!this.selectionLimit) {
      return;
    }
    if (_.countBy(this.comboboxElements, 'selected')["true"] === this.selectionLimit) {
      this.virtualScrollingHelper.disableElements(false);
    } else {
      this.virtualScrollingHelper.enableElements();
    }
  };
  Widget.prototype.onSelectionChange = function (data, addTrailingComma) {
    if (data.isSelectAll) {
      var minLimitExceeded = !data.selected && this.minSelection > 0;
      if (!minLimitExceeded) {
        this.wrongValues = [];
        this.selectAllItems(data.selected);
        this.virtualScrollingHelper.showData();
      }
    } else {
      this.wrongValues = [];
      if (this.minSelection) {
        this.validateMinSelection(data);
      }
      if (this.selectionLimit) {
        this.validateSelectionLimit(data);
      }
      this.toggleDisability();
      this.updateDataModel();
      this.selectAllElement.selected = !!this.selectedValues && this.selectedValues.length === this.comboboxElements.length;
      var inputValue = this.inputDomElement.val();

      /**
       * AVPRM-19571:
       * Adding a ',' at the end of the string since IE 11 removed from the input.
       */
      if (addTrailingComma && inputValue && !inputValue.match(/,$/g)) {
        inputValue += ',';
      }
      var selectedElementsValues = inputValue.split(',');
      var filterValue = selectedElementsValues.pop().trim();
      if (filterValue !== '') {
        if (data.selected) {
          this.updateResultField();
          if (this.visibleComboboxElements.length !== this.comboboxElements.length + 1) {
            this.visibleComboboxElements = multiSelectComboboxService.showAllComboboxElements(this.comboboxElements, this.selectAllElement, this.selectionLimit);
            this.virtualScrollingHelper.render(this.visibleComboboxElements);
          } else {
            this.virtualScrollingHelper.showData();
          }
        } else {
          var newInputValue = multiSelectComboboxService.getInputFieldValue(this.comboboxElements);
          if (newInputValue !== '') {
            newInputValue += ',';
          }
          this.updateResultField(newInputValue + filterValue);
          this.virtualScrollingHelper.showData();
        }
      } else {
        this.updateResultField();
        this.virtualScrollingHelper.showData();
      }
      this.inputDomElement.focus();
    }
  };
  Widget.prototype.render = function (comboboxValues) {
    this.comboboxElements = [];
    this.wrongValues = [];
    this.visibleComboboxElements = [];
    if (comboboxValues.length && !this.selectionLimit) {
      this.visibleComboboxElements.push(this.selectAllElement);
    }
    for (var i = 0; i < comboboxValues.length; i++) {
      var curItemData = comboboxValues[i];
      var item = new MultiSelectComboboxListItemFactory(curItemData);
      this.comboboxElements.push(item);
      this.visibleComboboxElements.push(item);
    }
    this.updateDataModel();
    this.selectAllElement.selected = !!this.selectedValues && this.selectedValues.length === this.comboboxElements.length;
    this.updateResultField();
    this.virtualScrollingHelper.render(this.visibleComboboxElements);
  };
  return Widget;
};
MultiSelectComboboxFactory.$inject = ['MultiSelectComboboxListItemFactory', 'MultiSelectComboboxSelectAllFactory', 'MultiSelectComboboxService', 'MultiSelectComboboxKeyHandlersFactory', 'MultiSelectComboboxVirtualScrollingHelper'];
module.exports = MultiSelectComboboxFactory;